module.exports = __webpack_public_path__ + "static/media/STABI R TURNTABLE.80cc170c.png";